function init() {
  // will use to ini log config
  // something like Raven js with Sentry
}

function log(error) {
  // eslint-disable-next-line
  console.log(error);
}

export default {
  init,
  log,
};
